// extracted by css-extract-rspack-plugin
export default {"modal":"IIjjwGw8AMXlf_o0","close":"zaGQz_b1MweyjF4S"};